import React, {Component} from 'react';


class Title extends Component {
	
  	render() {
    	return (
            <div className="content-header">
                <div className="header-section">
                    <h1><i className="gi gi-notes_2"></i>{this.props.title}</h1>
                </div>
            </div>
	    );
	}
}

export default Title;


// WEBPACK FOOTER //
// ./src/components/inc/Title.js